import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { RollMaterial } from "../models/RollMaterial";

export const getRollMaterials = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<RollMaterial[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollMaterials]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as RollMaterial[];
	}
	throw new Error(resp.message || "Error fetching roll materials");
};

export const upsertRollMaterial = async (
	material: RollMaterial,
): Promise<RollMaterial> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: material.Id },
		{ name: "Name", value: material.Name },
		{ name: "Active", value: material.Active },
	];

	const resp = await apiService.callV2(
		"[ROLLS].[UpsertRollMaterial]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as RollMaterial;
	}
	throw new Error(resp.message || "Error saving roll material");
};

export const removeRollMaterial = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2(
		"[ROLLS].[RemoveRollMaterial]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting roll material");
	}
};
